import { GenerationType } from 'components/BlazeCommandLine/api/createDocGenerationRequest'
import { SourceSelection } from './components/SourceSelection/SourceSelection'
import { observer } from 'mobx-react-lite'
import { MultiStepMobileWizard } from 'components/Wizards/MobileWizards/MultiStepMobileWizard/MultiStepMobileWizard'
import { SubmitStepProps } from 'components/Wizards/MobileWizards/MultiStepMobileWizard/Types'
import { FlowProps, TextValues } from 'components/Wizards/MobileWizards/Types'

type Values = Pick<
  TextValues,
  'filename' | 'brand_voice_id' | 'tone' | 'language' | 'brand_kit_id' | 'topic' | 'project'
> & {
  source_type?: string
  source_content?: string
  focus?: string
}

interface FlowH1Props extends FlowProps<GenerationType> {}

const FlowH1 = observer(({ schema, initialValues, ...props }: FlowH1Props) => {
  const defaultValues = {
    ...initialValues,
  }

  const handleSubmitStep = async ({ currentStep, totalSteps, values, advance }: SubmitStepProps<Values>) => {
    // For now, just advance to next step (when I add more steps)
    if (currentStep === totalSteps - 1) {
      // TODO: Handle final submission when I add more steps
      return
    }
    advance()
  }

  return (
    <MultiStepMobileWizard<Values>
      schema={schema}
      onSubmitStep={handleSubmitStep}
      initialValues={defaultValues}
      {...props}
    >
      <SourceSelection />
    </MultiStepMobileWizard>
  )
})

const FlowH1Container = (props: FlowProps<GenerationType>) => {
  return <FlowH1 {...props} />
}

export { FlowH1Container as FlowH1 }
